import axios from 'axios';

const base_url = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
    baseURL: base_url,
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Function to dynamically set up Axios interceptors with `auth`, `navigate`, and `setLoadError`.
 * @param {Object} auth - Auth context or object providing `setAuthenticated`.
 * @param {Function} navigate - Navigation function to redirect users.
 */
export const setupAxiosInterceptors = (auth: any, navigate: any) => {
    // Add request interceptor to attach the Authorization token
    axiosInstance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('token');
            if (token) {
                config.headers['authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // Add response interceptor to handle errors
    axiosInstance.interceptors.response.use(
        (response) => response, // Pass successful responses
        (error) => {
            if (error.response && (error.response.status === 403 || error.response.status === 401)) {
                // Set isAuthenticated to false and handle logout
                auth.setAuthenticated(undefined); // Mark the user as unauthenticated
                navigate('/login'); // Redirect to login page
            }
            return Promise.reject(error); // Reject the promise for other error handling
        }
    );
};

export default axiosInstance;